<template>
  <div class="footer-banner flex align-center justify-center">
    <img :src="image" alt="" />
    <div class="inner">
      <h1>{{ title }}</h1>
      <a :href="url" v-if="button" class="button ghost white">{{ button }}</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "Footer Banner Title",
    },
    url: {
      type: String,
      default: "/contact",
    },
    button: {
      type: String,
      default: "Button here",
    },
    image: {
      type: String,
      default: "/images/footer-stock.jpg",
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/utils/FooterBanner.vue